export default __webpack_public_path__ + "static/media/Student_Image.fa3ae3b3.png";